
var newPublicImg = "https://statics.eoffcn.com/statics/newIndexImg/public.png";
function browserRedirect() {
    var sUserAgent = navigator.userAgent.toLowerCase();
    var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    var bIsMidp = sUserAgent.match(/midp/i) == "midp";
    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    var bIsAndroid = sUserAgent.match(/android/i) == "android";
    var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        return false;//h5
    }else{
        
        return true;//pc
    }
}
export function onLoads(numberGoodsId){
    console.log(numberGoodsId, '$attrs.message2')
    $(".offcnNewMemberPoster_title a.a2").click(function(){
        // $("#purchase").show()
        window.location.href= "https://www.eoffcn.com/kaoshi/zhijiao/?sf=wxsyhyzx2&memberPoster=1";
    
    });
    if (browserRedirect()) {
        $(".offcnNewMemberPoster_hover").hover(function(){
        },function(){
            $(this).parent().css("z-index", "10");
            $(this).find(".div2").hide();
            $(this).find(".mored").removeClass("mores");
        });
        $(".offcnNewMemberPoster_hover .mored").hover(function(){
            $(this).parent().parent().parent().css("z-index", "1000000");
            $(this).parent().next(".div2").show();
            $(this).addClass("mores");
        })
    } else {
        $(".offcnNewMemberPoster_hover .mored").click(function(){
            var t = $(this).hasClass("mores");
            if (t) {
                $(this).removeClass("mores");
                $(this).parent().next(".div2").hide();
                $(this).parent().parent().parent().css("z-index", "10");
            } else {
                $(this).addClass("mores");
                $(this).parent().parent().parent().css("z-index", "1000000");
                $(this).parent().next(".div2").show();
            }
        });
    }

    var ht = window.location.href;
    var ajaxUrl = ht.indexOf('xue.eoffcn.com') < 0 ? "//ajax.t.eoffcn.com" : "//ajax.eoffcn.com";
    var openUrl = ht.indexOf('xue.eoffcn.com') < 0 ? "//www.t.eoffcn.com" : "//www.eoffcn.com";

    function numSize(){
        var s = $(".offcnNewMemberPoster_nav_ts .div2 .active").length;
        $(".offcnNewMemberPoster_nav_ts a b").text(s);
        $(".offcnNewMemberPoster_nav_ts a b").css("display", "inline-block");
        if (s<=0) {
            $(".offcnNewMemberPoster_nav_ts a b").css("display", "none");
        }
    }
    /**直播课开始**/
    function isTimeReached(start_time, end_time) {
        var currentTimestamp = Date.now(); // 当前时间戳
        var currentTime = new Date(currentTimestamp);
        var start_time = new Date(start_time*1000);
        var end_time = new Date(end_time*1000);
        
        var obj = {
            isStartTime: 0,
            isStartTime1: (start_time.getMonth()+1)+'月'+(start_time.getDate())+'日  '+(start_time.getHours())+':'+(start_time.getMinutes() < 12 ? "0"+start_time.getMinutes() : start_time.getMinutes()),
            isStartTime2: (end_time.getHours())+':'+(end_time.getMinutes() < 12 ? "0"+end_time.getMinutes() : end_time.getMinutes()),
        };
        if (currentTime < start_time) {
            obj.isStartTime = 0;
        }else if (currentTime >= start_time && currentTime <= end_time) {
            obj.isStartTime = 1;
        }else{
            obj.isStartTime = 2;
        }
        return obj;
    }
    function getRecentTeacherLive(){//获取直播信息
        $.ajax({
            url: ajaxUrl+"/api/getRecentTeacherLive", 
            type: "get",
            success: function (json) {
                if (json.data && json.data.length > 0) {
                    var data = json.data;
                    for (i in data){
                        // <div class="offcnLive_center_l offcnLive_center_l_active">
                        //     <div class="offcnLive_center_l_img">
                        //         <div class="oimg" style="background: url(https://statics.eoffcn.com/statics/newIndexImg/pc/js1.png) no-repeat center;  background-size: cover;"></div>
                        //     </div>
                        //     <div class="offcnLive_center_l_txt">
                        //         <b>2023财务人求职现状盘点-跳槽锦囊</b>
                        //         <span>梁春玮 | 12月23日 19:00-20:00</span>
                        //     </div>
                        //     <div class="offcnLive_center_l_bn">
                        //         <a>观看</a>
                        //         <span>直播中</span>
                        //     </div>
                        // </div>
                        var isTimeReacheds = isTimeReached(data[i].start_time, data[i].end_time);
                        $(".offcnLive_center_c").append(
                            '<div class="offcnLive_center_l '+(isTimeReacheds.isStartTime ==1 ? "offcnLive_center_l_active" : "")+' ">'+
                                '<div class="offcnLive_center_l_img">'+
                                    '<div class="oimg" style="background: url('+data[i].publicity_shots+') no-repeat center;  background-size: cover;"></div>'+
                                '</div>'+
                                '<div class="offcnLive_center_l_txt">'+
                                    '<b>'+data[i].name+'</b>'+
                                    '<span>'+data[i].teacher_name+' | '+isTimeReacheds.isStartTime1+'-'+isTimeReacheds.isStartTime2+'</span>'+
                                '</div>'+
                                '<div class="offcnLive_center_l_bn">'+
                                    '<a target="_blank" href="'+(data[i].url)+'">'+(isTimeReacheds.isStartTime == 1 ? "观看" : (isTimeReacheds.isStartTime == 2) ? "结束" : "预约" )+'</a>'+
                                    '<span>'+(isTimeReacheds.isStartTime == 1 ? "直播中" : (isTimeReacheds.isStartTime == 2) ? "已结束" : "未开始")+'</span>'+
                                '</div>'+
                            '</div>'
                        );
                    } 
                } else {
                    $(".offcnLive").hide();
                }
                
            }
        });
    }
    /**直播课结束**/
    /**师资展示开始**/
    var mySwiper1;
    function getRecommended(){
        var data = {
            limit: 8
        }
        $.ajax({
            url: ajaxUrl+"/api/teacher/recommended", 
            type: "post",
            data: data,
            success: function (json) {
                if (json.data && json.data.length > 0) {
                    var data = json.data;
                    var k = 0
                    for(var i in data) {
                        if (k % 5 == 0) {
                            k = 0;
                        }
                        k++;
                        // style="
                        var username = data[i].username ? '<b >'+data[i].username+'</b>' : '';
                        var subject = data[i].subject ? '<div><span>'+data[i].subject+'</span></div>' : '';
                        var title = data[i].title ? '<p title='+data[i].title+'>'+data[i].title+'</p>' : '';
                        var str = username+subject+title;
                        $(".offcnTeachers_sw .swiper-wrapper").append(
                            '<div class="swiper-slide bg'+k+'" data-url="'+openUrl+'/kaoshi/zhijiao/list.html?cupidTeachers='+data[i].id+'" >'+
                                '<div class="swImg" style="background: url('+data[i].publicity_shots+') no-repeat 0 0; background-size: cover;"></div>'+  
                                '<div class="swTxt">'+str+'</div>'+
                            '</div>'
                        );
                    }
                    
                    getRecommendedSw()
                    setTimeout(function() {
                        mySwiper1.update();
                    }, 100);

                    $(".offcnTeachers_sw .swiper-slide").click(function(){
                        window.location.href = $(this).attr("data-url");
                    })
                } else {
                    $(".offcnTeachers").hide();
                }
            }
        });
    }
    function getRecommendedSw(){
        mySwiper1 = new Swiper('.offcnTeachers_sw', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            loopFillGroupWithBlank: true,
            pagination: '.offcnTeachers_pagination',
            paginationClickable: true,
            autoplay: 3000, // 自动轮播间隔时间，单位为毫秒
            autoplayDisableOnInteraction: false, // 用户操作后是否停止自动轮播
            observer: true, //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true, //修改swiper的父元素时，自动初始化swiper
        });
        // if(browserRedirect()){
        //     var swiperContainer = document.querySelector('.offcnTeachers_sw');
        //     swiperContainer.addEventListener('mouseenter', function() {
        //         mySwiper1.stopAutoplay(); // 鼠标悬停时停止自动播放
        //     });
        //     swiperContainer.addEventListener('mouseleave', function() {
        //         mySwiper1.startAutoplay(); // 鼠标移出时继续自动播放
        //     });
        // }
    
    }
    getRecommended();
    /**师资展示结束**/
    /**网校会员new开始**/
    var advExamArr = [];
    
    function isElementInViewport(swiper) {//1,2级类目随动
            var firstNavItem = $('.offcnNewMemberPoster_nav_t .div1 .active');
            swiper.slideTo(firstNavItem.index());
            $('.offcnNewMemberPoster_nav .div2 span').on('click', function() {
                var index = $(this).index(); 
                var firstNavItem = $('.offcnNewMemberPoster_nav_t .div1 .active');
                swiper.slideTo(firstNavItem.index());
            });
    }
    function getAdvExam(category_ids, area_code){//获取广告一二级考试
        var categoryids =  category_ids ? category_ids.toString() : '';
        $.ajax({
            url: ajaxUrl+"/api/getAdvExam", 
            type: "post",
            data: {
                category_ids: categoryids,
            },
            success: function (json) {
                if (json.data && json.data.length > 0) {
                    var data = json.data;
                    var exam_id = "";
                    var filtSelected = data.filter((v) => v.selected == true);
                    if ( filtSelected.length > 0 ) {
                        var children = filtSelected[0].children && filtSelected[0].children.length > 0 ? filtSelected[0].children : 0;
                        if (children) {
                            var filtSelectedC = children.filter((v) => v.selected == true);
                            exam_id = filtSelectedC.length > 0 ? filtSelectedC[0].id : filtSelected[0].id;
                        } else {
                            exam_id = filtSelected[0].id;
                        }
                    } else {
                        exam_id = 0;
                    }
                    var eid = exam_id;
                    var jsonData = {
                        exam_id: eid,
                        area_code: area_code,
                    }
                    openBanner(jsonData);
                    for(var i in data) {
                        var children = data[i].children;
                        var cArr = [];
                        for(var v in children){
                            cArr.push(children[v].id);
                        }
                        
                        $(".offcnNewMemberPoster_nav_t .div1 div").append(
                            '<span class="'+(!isDetail() && !isYTYM() && i == 0 ? "active" : "")+' span'+data[i].id+'" isshow="1" data-id='+data[i].id+' data-cArr='+cArr+'>'+data[i].name+'</span>'
                        );
                        $(".offcnNewMemberPoster_nav_t .div2 ").append(
                            '<span  class="span'+data[i].id+'" data-id='+data[i].id+' isshow="1">'+data[i].name+'</span>'
                        );
                    }
                    $(".offcnNewMemberPoster_nav_t .div1 div").addClass('swiper-wrapper');
                    $(".offcnNewMemberPoster_nav_t .div1 div span").addClass('swiper-slide');
                    var ww =$(".offcnNewMemberPoster_nav_t .div1").outerWidth();
                    $(".offcnNewMemberPoster_nav_t .div1").css('width', ww+"px");
                    
                    var sp1 = '';
                    var sp2 = '';

                    // if (isDetail() || isYTYM()) {
                        if (eid) {
                            var eSzie= $(".offcnNewMemberPoster_nav_t .div1 div .span"+eid).length;
                            $(".offcnNewMemberPoster_nav_t .div1 div span").removeClass('active');
                            if (eSzie == 0) {
                                $(".offcnNewMemberPoster_nav_t .div1 div span").each(function(){
                                    var cid = $(this).attr("data-cArr") ? $(this).attr("data-cArr").split(",") : [];
                                    var incd= cid.includes(String(eid));
                                    if (incd) {
                                        sp1 = $(this).attr("data-id")
                                        sp2 = eid;
                                        return false;
                                    }
                                }); 
                                $(".offcnNewMemberPoster_nav_t .div1 div .span"+sp1).addClass('active');
                                $(".offcnNewMemberPoster_nav_t .div2 .span"+sp1).addClass('active');
                                if (!sp1 && !sp2){
                                    $(".offcnNewMemberPoster_nav_t .div1 div span").eq(0).addClass('active');
                                } 
                            } else{
                                $(".offcnNewMemberPoster_nav_t .div1 div .span"+eid).addClass('active');
                                $(".offcnNewMemberPoster_nav_t .div2 .span"+eid).addClass('active');
                            };
                        
                        } else {
                            $(".offcnNewMemberPoster_nav_t .div1 div span").eq(0).addClass('active');
                            $(".offcnNewMemberPoster_nav_t .div2 span").eq(0).addClass('active');
                        }
                    // } else {
                    //     $(".offcnNewMemberPoster_nav_t .div2 span").eq(0).addClass('active');
                    // }
                    var swiper = new Swiper('.offcnNewMemberPoster_nav_t .div1', {
                        slidesPerView: 'auto',
                        spaceBetween: 0,
                        loop: false,
                        loopFillGroupWithBlank: true,
                        observer: true, //修改swiper自己或子元素时，自动初始化swiper
                        observeParents: true, //修改swiper的父元素时，自动初始化swiper
                        // prevButton: '.offcnCourse-swiper-tcontainers .offcnCourse-button-tprev',
                        // nextButton: '.offcnCourse-swiper-tcontainers .offcnCourse-button-tnext',
                    });
                    advExamArr = data;
                    
                    totalWidths('.offcnNewMemberPoster_nav_t', 1);
                    navCk1(sp2);
                    
                    isElementInViewport(swiper);
                    ListPoster();

                } else {
                    // $(".offcnTeachers").hide();
                }
            }
        });
    }
    function navCk1(sp2){
        $(".offcnNewMemberPoster_nav_t span").click(function(){//会员广告一级级点击事件
            $(".offcnNewMemberPoster_nav_ts .div1 .mored").hide().removeClass("mores");
            $(".offcnNewMemberPoster_nav_ts .div1 .mored b").hide();
            $(".offcnNewMemberPoster_nav_ts .div2").hide().html("");
            $(".offcnNewMemberPoster_nav_t span").removeClass("active");
            var cid = $(this).attr('data-id');
            $(".offcnNewMemberPoster_nav_t .span"+cid).addClass("active");
            sp2 = "";
            examArrFilter(sp2);
            navCk2();
            
            ListPoster();
        });
        examArrFilter(sp2);
        navCk2();
    }
    function navCk2(){
        $(".offcnNewMemberPoster_nav_ts span").click(function(){//会员广告二级点击事件
            var t = $(this).hasClass("active");
            $(".offcnNewMemberPoster_nav_ts span").removeClass("active");
            if (t) {
                // $(this).removeClass("active");
            } else {
                $(this).addClass("active");
            }
            numSize();
            ListPoster();
        });
        numSize();

    }
    function examArrFilter(sp2){
        var fobj = advExamArr.filter(function(obj) {
            var id = $(".offcnNewMemberPoster_nav_t span.active").attr("data-id");
            return id == obj.id;
        });
        cArrFilter(fobj[0].children, sp2);

    }
        
    function cArrFilter(v,sp2){
        $(".offcnNewMemberPoster_nav_ts .div1 div").html('');
        if (v.length == 0) {
            $('.offcnNewMemberPoster_nav_ts').hide();
            return false;
        }
        $('.offcnNewMemberPoster_nav_ts').show();
        for (var i in v) {
            $(".offcnNewMemberPoster_nav_ts .div1 div").append(
                '<span class="span'+v[i].id+'" style="display: none;" isshow="0" data-id='+v[i].id+'>'+v[i].name+'</span>'
            );
        }
        totalWidths(".offcnNewMemberPoster_nav_ts", 2,sp2);
    }
    function totalWidths(vName, d,sp2){
        var totalWidth = 0;
        var ow = ($(vName+" .div1").outerWidth() * d) - ($(vName+" .div1 .mored").outerWidth() * d);
        $(vName+" .div1 div span").each(function() {
            var width = $(this).outerWidth(true);
            totalWidth += width;
            if (totalWidth < ow) {
                $(this).show().attr('isshow', 1);
            } else {
                $(vName+" .div1 .mored").css("display", "block"); 
                if (d != 1) {
                    var id = $(this).attr("data-id");
                    var name = $(this).text();
                    $(vName+" .div2").append(
                        '<span class="span'+id+'" isshow="1" data-id='+id+'>'+name+'</span>'
                    );
                
                }
            }
            if (d != 1 && sp2) {
                $(".offcnNewMemberPoster_nav_ts .span"+sp2).each(function(){
                    if ($(this).attr('isshow') == 1) {
                        $(this).addClass("active");
                    }
                })
            }
        });
    }
    function ListPoster() {//会员分类广告
        var exam_ids = [];
        var s = $('.offcnNewMemberPoster_nav_ts span.active').length;
        if (s <= 0){
            var dataId = $('.offcnNewMemberPoster_nav_t .div1 .active').attr('data-id');
            exam_ids.push(parseInt(dataId));
        } else {
            var sc = $('.offcnNewMemberPoster_nav_ts .div2 .active').length;
            $('.offcnNewMemberPoster_nav_ts .div1 .active').each(function(){
                var dataId = $(this).attr('data-id');
                exam_ids.push(parseInt(dataId));
            })
            if (sc > 0 ) {
                $('.offcnNewMemberPoster_nav_ts .div2 .active').each(function(){
                    var dataId = $(this).attr('data-id');
                    exam_ids.push(parseInt(dataId));
                })
            }
        };
        if(exam_ids.length == 0){
            $(".offcnNewMemberPoster_ceb").html('');
            return false;
        }
        var data = {
            exam_ids: exam_ids
        };
        $.ajax({
            url: ajaxUrl+"/api/getCategoryMemberAdv", 
            type: "post",
            data: data,
            success: function (json) {
                var memberZeroGoodsListSlice = json.data.memberZeroGoodsListSlice;//免费
                var memberTHGoodsListSlice = json.data.memberTHGoodsListSlice;//特惠
                ListPosterData(memberZeroGoodsListSlice, 0);
                ListPosterData(memberTHGoodsListSlice, 1);
            }
        });
    
    }
    function ListPosterData(data, v) {
        $(".offcnNewMemberPoster_tab .offcnNewMemberPoster_tabs").eq(v).find(".offcnNewMemberPoster_ceb").html('');
        for(var i in data) {
            var is_member_goods = data[i].is_member_goods;
            var priceType = data[i].promotion_price;
            var has_specification = data[i].has_specification;
            var price = data[i].price;

            if (is_member_goods == 2 || is_member_goods == 3) {
                if (has_specification) {
                    priceType = data[i].promotion_price+ '起';
                    price = data[i].price+ '起';
                } else{
                    priceType = data[i].promotion_price == 0 ? '免费' : data[i].promotion_price;
                    price = data[i].price;
                }
            } else { 
                if (has_specification) {
                    priceType = data[i].price+ '起';
                    price = data[i].price+ '起';
                } else{
                    priceType = data[i].price == 0 ? '免费' : data[i].price;
                    price = data[i].price;

                }
            }
            var list = '<div class="offcnNewMemberPoster_list" data-url='+data[i].url+'>'+
                            '<div class="offcnNewMemberPoster_img" style="background: url('+(data[i].picture ? data[i].picture : newPublicImg)+') no-repeat center top;background-size:cover;">'+
                                // '<div class="offcnNewMemberPoster_right_heat">123</div>'+
                                '<div class="offcnNewMemberPoster_right_bf"></div>'+
                            '</div>'+
                            '<div class="offcnNewMemberPoster_txt">'+
                                '<p>'+data[i].name+'</p>'+
                                '<div class="vip_center">'+
                                    '<div class="vPrice">'+
                                        '<span>'+priceType+'</span>'+
                                    '</div>'+
                                    '<div class="yPrice">'+
                                        '<span>¥ '+price+'</span>'+
                                    '</div>'+
                                '</div>'+
                            '</div>'+
                        '</div>';
            $(".offcnNewMemberPoster_tab .offcnNewMemberPoster_tabs").eq(v).find(".offcnNewMemberPoster_ceb").append(list);
            
        }
        
        $(".offcnNewMemberPoster_tab .offcnNewMemberPoster_tabs").eq(v).find(".offcnNewMemberPoster_ceb").append('<a class="mored" target="_blank">查看更多</a>');
        $(".offcnNewMemberPoster_list").click(function(){
            window.location.href = $(this).attr("data-url");
        })
        $(".offcnNewMemberPoster_list").click(function(){
            window.location.href = $(this).attr("data-url");
        })
        $(".offcnNewMemberPoster_tab .mored").click(function(){
            openHref();
        })
    }
    /**网校会员new结束**/
    /**banner开始**/
    var mySwiper2 = ''
    function itemBanner(v){//频道页banner图
            var url =  window.location.pathname;
            var search_name = url.split("/").filter(Boolean).pop().split("?")[0];
            var imgUrl = "//statics.eoffcn.com/statics/images/banner_bg.jpg";
            $.ajax({
                url: ajaxUrl+"/api/banner/info", 
                type: "post",
                data: {
                    search_name: search_name ? search_name : 'gwy',
                    area_code: 100000,
                },
                success: function (json) {
                    var data = json.data;
                    if(data && data.length > 0){
                        $(".offcnNewBanner").show();
                        for (var i in data) {
                            $(".offcnNewBanner .offcnNewBanner_sw .swiper-wrapper").append(
                                '<div class="swiper-slide" data-url='+data[i].jump_url+' style="background: url('+(data[i].image ? data[i].image : imgUrl)+') no-repeat center;  background-size: cover;" data-id='+data[i].goods_id+'>'+
                                    '<div class="offcnNewBannerImg" style="display: '+(data[i].image ? 'none' : 'block')+';">'+
                                        '<b>'+data[i].jz_name+'</b>'+
                                        '<span>'+data[i].jz_image_name+'</span>'+
                                    '</div>'+
                                '</div>'
                            );
                        }
                        offcnNewBanner_sw();
                        $(".offcnNewBanner .swiper-slide").click(function(){
                            window.location.href = $(this).attr("data-url");
                        })
                    } else {
                        $(".offcnNewBanner").hide();
                    };
                }
            });
    }
            
    function openBanner(v){
        var data = v ? v : '';
        var imgUrl = "//statics.eoffcn.com/statics/images/banner_bg.jpg";
        if (ht.indexOf('/kaoshi/') > 0){
            itemBanner();
            return false;
        }
        $.ajax({//获取列表页，详情页banner
            url: ajaxUrl+"/api/getAdvBanner", 
            type: "post",
            data: data,
            success: function (json) {
                var data = json.data;
                if(data && data.length > 0){
                    $(".offcnNewBanner").show();
                    for (var i in data) {
                        $(".offcnNewBanner .offcnNewBanner_sw .swiper-wrapper").append(
                            '<div class="swiper-slide" data-url='+data[i].jump_url+' style="background: url('+(data[i].image ? data[i].image : imgUrl)+') no-repeat center;  background-size: cover;" data-id='+data[i].goods_id+'>'+
                                '<div class="offcnNewBannerImg" style="display: '+(data[i].image ? 'none' : 'block')+';">'+
                                    '<b>'+data[i].jz_name+'</b>'+
                                    '<span>'+data[i].jz_image_name+'</span>'+
                                '</div>'+
                            '</div>'
                        );
                    }
                    offcnNewBanner_sw();
                    $(".offcnNewBanner .swiper-slide").click(function(){
                        window.location.href = $(this).attr("data-url");
                    })
                } else {
                    $(".offcnNewBanner").hide();
                };
            }
        });
    }
    function offcnNewBanner_sw(){
        var mySwiper2 = new Swiper('.offcnNewBanner_sw', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            loopFillGroupWithBlank: true,
            pagination: '.offcnNewBanner_pagination',
            paginationClickable: true,
            autoplay: 3000, // 自动轮播间隔时间，单位为毫秒
            autoplayDisableOnInteraction: true, // 用户操作后是否停止自动轮播
            observer: true, //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true, //修改swiper的父元素时，自动初始化swiper
        });
        // if(browserRedirect()){
        //     var swiperContainer = document.querySelector('.offcnNewBanner_sw');
        //     swiperContainer.addEventListener('mouseenter', function() {
        //         mySwiper2.stopAutoplay(); // 鼠标悬停时停止自动播放
        //     });
        //     swiperContainer.addEventListener('mouseleave', function() {
        //         mySwiper2.startAutoplay(); // 鼠标移出时继续自动播放
        //     });
        // }
    }
    function isDetail(){//判断是否是详情页  用于banner图传传考试id
        if (hurl.indexOf('detail/') > 0 || hurl.indexOf('/n/') > 0){
            return true;
        } else {
            return false;
        }
    }
    function isYTYM(){//判断是否是一题一码页  用于前台考试默认值和banner图传传考试id
        if (hurl.indexOf('ytym') > 0){
            return true;
        } else {
            return false;
        }
    }
    /**banner结束**/
    /**获取广告默认搜索条件开始**/
    var hurl = window.location.href;
    function getAdvDefaultCondition(){//广告默认搜索条件
        console.log(numberGoodsId, 'numberGoodsId');
        var data = {
            type: 3,
            key: numberGoodsId ? numberGoodsId : 496200 ,
        }
        $.ajax({
            url: ajaxUrl+"/api/getAdvDefaultCondition", 
            type: "get",
            data: data,
            success: function (json) {
                var data = json.data;
                if (data) {
                    var sdata = data;
                    var category_ids = data.category_ids;
                    
                    getAdvExam(category_ids, sdata.area_code);
                   
                    var show_open_teacher = sdata.show_open_teacher;
                    if (show_open_teacher) {
                        getRecentTeacherLive();
                        $(".offcnLive, .offcnTeachers").show();
                        $(".offcnLive, .offcnTeachers").show();
                    } else{
                        $(".offcnLive, .offcnTeachers").hide();
                    }
                    // $.ajax({
                    //     url: ajaxUrl+"/api/getAdvExam", 
                    //     type: "post",
                    //     data: {
                    //         category_ids: category_ids.toString(),
                    //     },
                    //     success: function (json) {
                    //         var data = json.data;
                    //         var exam_id = "";
                    //         var filtSelected = data.filter((v) => v.selected == true);
                    //         if ( filtSelected.length > 0 ) {
                    //             var children = filtSelected[0].children && filtSelected[0].children.length > 0 ? filtSelected[0].children : 0;
                    //             if (children) {
                    //                 var filtSelectedC = children.filter((v) => v.selected == true);
                    //                 exam_id = filtSelectedC.length > 0 ? filtSelectedC[0].id : filtSelected[0].id;
                    //             } else {
                    //                 exam_id = filtSelected[0].id;
                    //             }
                    //         } else {
                    //             exam_id = 0;
                    //         }
                    //         getAdvExam(exam_id);
                    //         var jsonData = {
                    //             exam_id: exam_id,
                    //             area_code: sdata.area_code,
                    //         }
                    //         openBanner(jsonData);
                    //         var show_open_teacher = sdata.show_open_teacher;
                    //         if (show_open_teacher) {
                    //             getRecentTeacherLive();
                    //             $(".offcnLive, .offcnTeachers").show();
                    //             $(".offcnLive, .offcnTeachers").show();
                    //         } else{
                    //             $(".offcnLive, .offcnTeachers").hide();
                    //         }
                    //     }
                    // })
                }

            }
        });
    }
    getAdvDefaultCondition();
    // if (isDetail()){
    //     getAdvDefaultCondition();
    // } else {
    //     if (isYTYM() && $('.cupid').attr('data-examID')) {
    //         getAdvExam($('.cupid').attr('data-examID'));
    //         openBanner({exam_id: $('.cupid').attr('data-examID')});
    //     } else {
    //         getAdvExam();
    //         openBanner();
    //     }
    //     getRecentTeacherLive();
    //     $(".offcnLive, .offcnTeachers").show();
    // }
    /**获取广告默认搜索条件结束**/
    if (!browserRedirect()){
        $('.offcnhd').append(
            '<div class="mask">'+
                '<div class="imgBox">'+
                    '<img class="img1" src="https://statics.eoffcn.com/statics/js/zx/ip/zximg/h5/close.png">'+
                        '<img class="img2" src="https://s.eoffcn.com/ds/202401/e48359a34f8ab8aded878b0ff0677cf6_1705904857000_4098.jpg">'+
                    '<p>长按保存二维码</p>'+
                '</div>'+
            '</div>'
        )
    }
    $(".offcnhd .a2").click(function(){
        window.location.href="https://www.eoffcn.com/kszn/ads/lingke/";
        // if (!browserRedirect()){
        //     var ua = navigator.userAgent.toLowerCase();
        //     if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //         $('.offcnhd .mask').show();
        //         $('.offcnhd .mask .imgBox .img1').click(() => {
        //         $('.offcnhd .mask').hide();
        //     });
        //     } else {
        //         window.open('https://cloud1-9gm1jh9440f32a57-1305285725.tcloudbaseapp.com/gocontact.html?type=0&groupLinkImg=https://s.eoffcn.com/ds/202401/e48359a34f8ab8aded878b0ff0677cf6_1705904857000_4098.jpg');
        //     }
        // }
    })
    if (!browserRedirect()){
        $(".offcnhd a.a3").click(() => {
            $('.m-zx-sider-tm').show()
            $('.m-zx-sider-fx1').show().addClass('fadeInUp')
        });
    } else {
        $('.offcnhd a.a3, .zx-side .emphasis .hover_pc, .zx-side .emphasis').hover(() => {
            $('.zx-side .emphasis .hover_pc').show();
        }, () => {
            $('.zx-side .emphasis .hover_pc').hide();
        });
    }

    var d = {
        search_name: itemUrl()
    }
    if (!itemUrl()) {
        d = {};
    }
        
    // 金刚区
    $.ajax({
        url: ajaxUrl+"/api/getJinGangQuList",
        type: "post",
        data: d,
        success: function (data) {
            var jinGang_html = "";
            if (data.data && data.data.length) {
                data.data.forEach((i, inx) => {
                    jinGang_html += 
                    `
                        <div class="swiper-slide" data-inx="${inx}">
                            <div class="img">
                                <img src="${i.image}" alt="">
                            </div>
                            <div class="tip">${i.jz_name}</div>
                        </div>
                    `
                });
                $('.jinGang .swiper-wrapper').html(jinGang_html);
                $('.jinGang .swiper-wrapper .swiper-slide').click(function () {
                    var inx = $(this).attr("data-inx");
                    if (data.data[inx].type === 5) {
                        if (data.data[inx].wx_scheme_url) {
                            location.href = data.data[inx].wx_scheme_url;
                        } else {
                            location.href = 'https://cloud1-9gm1jh9440f32a57-1305285725.tcloudbaseapp.com/index.html';
                        }
                    } else {
                        if (data.data[inx].jump_url) {
                            window.open(data.data[inx].jump_url);
                        }
                    }
                });
                // 金刚区
                var jinGang_Swiper = new Swiper ('.jinGang', {
                    slidesPerView: 5,
                    slidesPerGroup : 5,
                    spaceBetween : 23,
                    speed: 500,
                    loopFillGroupWithBlank: true,
                    pagination: '.swiper-pagination',
                });
            };
        }
    });
    getAdvExamTree();
    function matchUrl(url){//详情页ID
        var match = url.match(/\d+/);
        if (match) {
            var number = match[0];
            return number;
        } else {
            return false;
        }
    }
    function itemUrl() {//频道页分类
        var url = ht;
        var match = url.match(/kaoshi\/([^\/?]+)/);
        var Value = match ? match[1] : "";
        return Value;
    }
    function hrefs(t){
        window.open($(t).attr("data-url"), "_blank");
    }
    function openHref(){

        if (isZaiXianKeTang()) {
            var d={
            "index":1
        };
        if(isiOS){
            window.webkit.messageHandlers.goIndex.postMessage(d);
        }else if(isAndroid){
            window.androidJS.goIndex(d); 
        };
        } else if (isXiaoChengXu()) {
        wx.miniProgram.navigateTo({
            url: '/pages/index/index'
        });
        } else {
            window.open("https://www.eoffcn.com/kaoshi/zhijiao/list.html?commodityId=160800");
    };
    }
    function isXiaoChengXu() {
        var xcx;
        wx.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
                xcx = true;
            } else {
                xcx = false;
            }
            return xcx;
        })
        if (xcx == true) {
            return true;
        } else {
            return false;
        }
    }

        
    // 在线课堂APP
    function isZaiXianKeTang() {
        var userAgent = window.navigator.userAgent.toLowerCase();
        if (userAgent.indexOf('zaixianketang') > -1 || userAgent.search('zaixianketang') > -1) {
            return true;
        } else {
            return false;
        }
    }
    var ExamLeafTree = '';
    var newExamLeafTree = [];
    function getAdvExamTree(){
        $.ajax({
            url: ajaxUrl+"/api/getAdvExamTree", 
            type: "get",
            // data: data,
            success: function (json) {
                var data = json.data.ExamLeafTree;
                // ExamLeafTree = data;
                for(var i in data){
                    newExamLeafTree.push(
                        {
                            id: data[i].id,
                            name: data[i].name,
                            children: data[i].children.length > 0 ? data[i].children : "",
                            examId: data[i].children.length > 0 ? 1 : 0,
                        }
                    );
                }
                offcnCourseNav();
            }
        });
    }
    function getCategoryAdvApi(v) {
        if (v !== 1) {
            var elementTop = $('.offcnCourseh5').offset().top;
            $("body,html").animate({ scrollTop: elementTop}, 0);
        }
        var examId =  $(".offcnCourseh5_right .offcnCourseh5_nav .active").attr("data-id");
        if (!examId) {
            examId = $(".offcnCourseh5_left span.active").attr("data-id");
        } else {
            examId =  $(".offcnCourseh5_right .offcnCourseh5_nav .active").attr("data-id");
        }
        $.ajax({
            url: ajaxUrl+"/api/getCategoryAdv?exam_id="+examId, 
            type: "get",
            beforeSend: function() {
                // console.log("加载中...");
                $(".offcnCourseh5_center").hide();
                $(".onRecord").show();
            },
            success: function (json) {
                var data= json.data;
                if (data) {
                    var newCategoryAdvData = [
                        {//重要公告
                            type:['重要公告','面试公告','报考数据'],
                            article: [data.information, data.interview_information, data.sign_information],//重要公告&报考数据文章
                            product: ''//重要公告商品
                        },
                        {//高端课程
                            type:['高端课'],
                            article: [data.poster],//高端课程文章
                            product: data.course_top//高端课程商品
                        },
                        {//公开课
                            type:['公开课'],
                            article: [],//公开课文章
                            product: data.course_open//公开课商品
                        },
                        {//会员0元课
                            type:['会员免费课'],
                            article: [],//会员0元课文章
                            product: data.course_vip_free//会员0元课商品
                        },
                        {//会员特惠课
                            type:['会员特惠课'],
                            article: [],//会员特惠课文章
                            product: data.course_vip_preferential//会员特惠课商品
                        },
                        {//备考资料
                            type:['备考资料'],
                            article: [data.material],//备考资料文章
                            product: ''//备考资料商品
                        },
                        {//考试题库
                            type:['考试题库'],
                            article: [data.question],//考试题库文章
                            product: ''//考试题库商品
                        },
                    ]
                
                    getCategoryAdvApiList(newCategoryAdvData);
                }
            },
            complete: function() {
                // console.log("加载完成");
                $(".offcnCourseh5_center").show();
                $(".onRecord").hide();
            }
        });
    }
    function interactionShow() {
        $(".offcnCourseh5_title_fx span").click(function(){
            $(this).parent(".offcnCourseh5_title_fx").find("span").removeClass("active");
            $(this).addClass("active");
            var t = $(this).index();
            var pe = $(this).parent(".offcnCourseh5_title_fx").parent(".offcnCourseh5_title").parent(".offcnCourseh5_div");
            pe.find(".open_ul ul").hide();
            pe.find(".open_ul ul").eq(t).show();
            var elementTop = $('.offcnCourseh5').offset().top;
            $("body,html").animate({ scrollTop: elementTop}, 0);
        });
        
        console.log($(".offcnCourseh5_center").height(), "aaaaaa")
        if ($(".offcnCourseh5_center").height() <= $(window).height()){
            $(".offcnCourseh5 .offcnCourseh5_height, .offcnCourseh5_right .offcnCourseh5_fx").css({
                "position": "relative",
                "top": "0px",
            })
            return false;
        }
        $(window).scroll(function() {
            console.log(1, "he_nav");
            var scrollTop = $(this).scrollTop();
            var elementTop = $('.offcnCourseh5').offset().top;
            var he = $(".offcnCourseh5 .offcnCourseh5_height");
            var he_nav = $(".offcnCourseh5 .offcnCourseh5_nav");
            var he_nav_fx = he_nav.find(".offcnCourseh5_fx");
            console.log(he_nav.width(), "he_nav");
            if ($(".offcnCourseh5_center").height() <= $(window).height()){
                $(".offcnCourseh5 .offcnCourseh5_height").css({
                    "position": "relative",
                    "top": "0px",
                })
                return false;
            }
            if (elementTop - scrollTop <= 0) {
                he.css({
                    "position": "fixed",
                    "top": "0",
                });
                he_nav_fx.css({
                    "position": "fixed",
                    "top": "0",
                    "width": he_nav.width()+"px",
                });
                if ((elementTop + $(".offcnCourseh5").height() - he.height()) - scrollTop <= 0) {
                    var zh =  $(".offcnCourseh5_right").height() - he.height();
                    he.css({
                        "position": "absolute",
                        "top": zh+"px",
                    });
                } else{
                    he.css({
                        "position": "fixed",
                        "top": "0",
                    });
                };
                if ((elementTop + $(".offcnCourseh5").height() - he_nav.height()) - scrollTop <= 0) {
                    var zh =  $(".offcnCourseh5_right").height() - he_nav.height();
                    he_nav_fx.css({
                        "position": "absolute",
                        "top": zh+"px",
                    });
                } else{
                    he_nav_fx.css({
                        "position": "fixed",
                        "top": "0",
                    });
                };
            } else {
                $(".offcnCourseh5 .offcnCourseh5_height").removeClass("offcnCourseh5_height_fx");
                he.css({
                    "position": "relative",
                    "top": "0",
                });
                he_nav_fx.css({
                    "position": "relative",
                    "top": "0",
                    "width": he_nav.width()+"px",
                });
            }
            scrollTopList(scrollTop)
        });
    }
    function scrollTopList(scrollTop) {
        $(".offcnCourseh5_center .offcnCourseh5_div").each(function(){
            var t = $(this);
            var h = $(".offcnCourseh5_nav .swiper-wrapper span").length > 0 ? $(".offcnCourseh5_nav").height() : 0;
            var elementTop = t.offset().top;
            if (elementTop - (scrollTop + h) <= 0) {
                console.log(t.index(), "index")
                t.find(".offcnCourseh5_title_fx").css({
                    "position": "fixed",
                    "top": h+"px",
                    "width": t.width()+"px",
                });
                console.log(h, "hei")
                if ((elementTop + t.height() - ((h - 2.5) + (t.find(".offcnCourseh5_title").height()))) - (scrollTop) <= 0) {
                    t.find(".offcnCourseh5_title_fx").css({
                        "position": "absolute",
                        "top": ((t.height() - (h ? h : t.find(".offcnCourseh5_title").height())))+"px",
                        "width": t.width()+"px",
                    });
                }
            } else {
                t.find(".offcnCourseh5_title_fx").css({
                    "position": "relative",
                    "top": "0",
                });
            }
            // if ((elementTop + $(".offcnCourseh5").height() - t.height()) - scrollTop <= 0) {
            //     console.log(t.index(), "index")
            // }
        });
    }
    function getCategoryAdvApiList(data) {
        $(".offcnCourseh5, .offcnCourseh5_left, .offcnCourseh5_right").css("min-height", "auto");
        $(".offcnCourseh5_center").html("");
        for (var i in data){
            var type = data[i].type;
            var getTitleHTMLs = getTitleHTML(type, data[i])
            var getArticleHTMLs = getArticleHTML(data[i].article, data[i].type)
            var getProductHTMLs = getProductHTML(data[i].product.list)
            if (getArticleHTMLs.indexOf("indexLi") > 0 || getProductHTMLs.indexOf("offcnCourseh5_product_list") > 0) {
                $(".offcnCourseh5_center").append(
                    '<div class="offcnCourseh5_div">'
                        +getTitleHTMLs+getArticleHTMLs+getProductHTMLs+
                    '</div>'
                );
            }

        }
        $(".offcnCourseh5_center .offcnCourseh5_div").each(function(){
            $(this).find(".offcnCourseh5_product").length;
        });
        var rh = $(".offcnCourseh5_right").height();
        $(".offcnCourseh5_right").css("min-height", rh+"px");
        
        heights();
        interactionShow();//商品&文字交互
        $(".offcnCourseh5_product_list").click(function(){  
            openHref();
        })
    }
    var lodMore = '';
    function getProductHTML(data) {
        var productHTML = '';
        if (data){
            productHTML += '<div class="offcnCourseh5_product">';
            for (var i in data) {
                var is_member_goods = data[i].is_member_goods;
                    var priceType = data[i].promotion_price;
                    var has_specification = data[i].has_specification;
                    var price = data[i].price;
                    /**202402011134修改**/
                    if (is_member_goods == 2 || is_member_goods == 3) {
                        if (has_specification) {
                            priceType = data[i].promotion_price+ '起';
                            price = data[i].price+ '起';
                        } else{
                            priceType = data[i].promotion_price == 0 ? '免费' : data[i].promotion_price;
                            price = data[i].price;
                        }
                    } else { 
                        if (has_specification) {
                            priceType = data[i].price+ '起';
                            price = data[i].price+ '起';
                        } else{
                            priceType = data[i].price == 0 ? '免费' : data[i].price;
                            price = data[i].price;

                        }
                    }
                productHTML += '<div class="offcnCourseh5_product_list" data-href="'+data[i].url+'">'+
                                    '<div class="offcnCourseh5_list_img" style="background: url('+(data[i].picture ? data[i].picture : "https://statics.eoffcn.com/statics/newIndexImg/public.png")+') no-repeat center top;background-size: cover;">'+
                                        // '<div class="d1">1231</div>'+
                                        '<div class="d2"></div>'+
                                    '</div>'+
                                    '<div class="offcnCourseh5_list_r">'+
                                        '<div class="d1">'+data[i].name+'</div>'+
                                        '<div class="d2">'+
                                            '<div class="price">'+priceType+'</div>'+
                                            '<div class="oPrice">￥'+price+'</div>'+
                                        '</div>'+
                                    '</div>'+
                                '</div>'
            }
            productHTML += "</div>";

        } else {
            productHTML = ""
        }
        
        return productHTML;
    }
    function getArticleHTML(data, type) {
        var ArticleHTML = '';

        if (data.length > 0){
            ArticleHTML = '<div class="open_ul">';
                for (var i in data) {
                    if (data[i].list.length > 0) {
                        ArticleHTML += '<ul style="display: '+(i == 0 ? "block" : "none")+'">';
                        var list = data[i].list;
                        for(var k in list) {
                            ArticleHTML += '<li class="indexLi">'+
                                                '<a href="'+list[k].url+'">'+list[k].title+'</a>'+
                                                '<span style="display: '+(type.indexOf("高端课") >= 0 ? "none" : "block")+'">'+list[k].publish_time+'</span>'+
                                            '</li>';
                        }
                        ArticleHTML += '</ul>'
                    }
                    
            
                }
                    
            ArticleHTML += '</div>';
        } else {
            ArticleHTML = " ";
        }
        
        return ArticleHTML;
    }
    function getTitleHTML(type, data) {
        var typeHtml = '';
        typeHtml = '<div class="offcnCourseh5_title"><div class="offcnCourseh5_title_fx">';
        var ckMore = '';
        for (var i in type) {
            if (data.product) {
                ckMore = data.product.more;
                lodMore = data.product.more;
            } else {
                ckMore = data.article[i].more;
                lodMore = data.article[0];
            }
            if ((data.article[i] && data.article[i].list.length > 0) || (data.product.list && data.product.list.length > 0)) {
                typeHtml += '<span class='+(i == 0 ? "active" : "span")+' data-more="'+ckMore+'">'+type[i]+'</span>';
            } 
        }
        typeHtml+= '<a href="'+lodMore+'">更多</a>';
        typeHtml+= "</div></div>";
        return typeHtml;
    }
    function offcnCourseNav(){
        if (!newExamLeafTree) {
            return false;
        }
        for(var i in newExamLeafTree){
            $(".offcnCourseh5_left .swiper-wrapper").append('<span class="swiper-slide '+(i ==0 ? "active" : "")+'" data-id='+newExamLeafTree[i].id+'>'+newExamLeafTree[i].name+'<i></i></span>');
        }
        heights();
        var offcnCourseh5_left = new Swiper('.offcnCourseh5_height', {//
            direction: 'vertical',slidesPerView: 'auto',
            spaceBetween: 0,
            loop: false,
            loopFillGroupWithBlank: true,
            // 其他配置选项
        });
        var offcnCourseh5_right_nav = new Swiper('.offcnCourseh5_fx', {
            direction: 'horizontal',slidesPerView: 'auto',
            spaceBetween: 0,
            loop: false,
            loopFillGroupWithBlank: true,
            // 其他配置选项
        });
        ckChildren(offcnCourseh5_right_nav, 1);
        offcnCourseLeftNav();

        $(".offcnCourseh5_left span").click(function(){
            if ($(this).hasClass("active")) {
                return false;
            };
            $(".offcnCourseh5_left span").removeClass("active");
            $(this).addClass("active");
            
            var rh = $(".offcnCourseh5_right").height();
            $(".offcnCourseh5_right").css("min-height", rh+"px");
            ckChildren(offcnCourseh5_right_nav, 0);
            offcnCourseLeftNav();
            var s = $(".offcnCourseh5_right .offcnCourseh5_nav .swiper-wrapper span").length;
            if (s <= 0) {
                $(".offcnCourseh5_right .offcnCourseh5_nav").hide();
            } else {
                $(".offcnCourseh5_right .offcnCourseh5_nav").show();
            }
            var www = $(".offcnCourseh5_nav").width();
            $(".offcnCourseh5_fx").css("width", www+"px");
            console.log(www, "wwww")
            if(offcnCourseh5_right_nav && offcnCourseh5_right_nav.update){
                offcnCourseh5_right_nav.update(); 
                offcnCourseh5_right_nav.slideTo(0, 0);
            }
        });
    }
    function heights(){
        var h = $(".am-navbar").length > 0 ? $(window).height()-( $(".am-navbar").length > 0 ? $(".am-navbar").height() : 0) : $(window).height();
        var hs = "";
        if ($(".offcnCourseh5").height() < h) {
            $(".offcnCourseh5_center").css("height", h+"px");
            hs = h;
        } else {
            $(".offcnCourseh5_center").css("height", "auto");
            hs = $(".offcnCourseh5").height();
        }
        $(".offcnCourseh5_left").css("height", hs+"px");
        $(".offcnCourseh5_left .offcnCourseh5_height").css("height", (h)+"px");
        
        var ww = $(".offcnCourseh5_left").width();
        $(".offcnCourseh5_left .offcnCourseh5_height").css("width", ww+"px");
        
    }
    function ckChildren(offcnCourseh5_right_nav, v){
        var id = $(".offcnCourseh5_left span.active").attr('data-id') ? $(".offcnCourseh5_left span.active").attr('data-id') : newExamLeafTree[0].id;
        let filterExamLeafTree = newExamLeafTree.filter(obj => obj.id == id)[0].children;
        $(".offcnCourseh5_right .offcnCourseh5_nav .swiper-wrapper").html("");
        for (var i in filterExamLeafTree) {
            $(".offcnCourseh5_right .offcnCourseh5_nav .swiper-wrapper").append('<span class="swiper-slide '+(i ==0 ? "active" : "")+'" data-id='+filterExamLeafTree[i].id+'>'+filterExamLeafTree[i].name+'</span>')
        }  
        if(offcnCourseh5_right_nav && offcnCourseh5_right_nav.update){
            offcnCourseh5_right_nav.update(); 
            offcnCourseh5_right_nav.slideTo(0, 0);
        }
        var s = $(".offcnCourseh5_right .offcnCourseh5_nav .swiper-wrapper span").length;
        if (s <= 0) {
            $(".offcnCourseh5_right .offcnCourseh5_nav").hide();
        } else {
            $(".offcnCourseh5_right .offcnCourseh5_nav").show();
        }
        $(".offcnCourseh5_right .offcnCourseh5_nav span").click(function(){
            if ($(this).hasClass("active")) {
                return false;
            };
            console.log("aaaa", "asdasdasdasd")
            $(".offcnCourseh5_right .offcnCourseh5_nav span").removeClass("active");
            $(this).addClass("active");
            getCategoryAdvApi(0);
        });
        getCategoryAdvApi(v);

    }
    function offcnCourseLeftNav(){
        $(".offcnCourseh5_left span").removeClass("spanUp spanAfter");
        $(".offcnCourseh5_left span").eq($(".offcnCourseh5_left span.active").index()-1).addClass("spanUp");
        $(".offcnCourseh5_left span").eq($(".offcnCourseh5_left span.active").index()+1).addClass("spanAfter");

    }

    $(".zhichi").click(function(){
        var ht = window.location.href;
        var hr = ht.indexOf('xue.eoffcn.com') < 0 ? "//xue.t.eoffcn.com" : "//xue.eoffcn.com"
        window.location.href = hr+'/web/zgwxxcx.html';
    })
}


//////////////////
// WEBPACK FOOTER
// ./static/js/CupidStyle/js/pubilc.js
// module id = GxN/
// module chunks = 6